import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import LazyImage from "@insite/mobius/LazyImage";
import MobiusLink from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface CustomMenuModelINT {
    fields: {
        image: string;
        description: string;
        title: string;
        linklearnmore: string;
        link: string;
        overrideTitle: string;
        openInNewWindow: boolean;
    };
}

const enum fields {
    title = "title",
    CustomMenuItem = "menuItem",
    linklearnmore = "linklearnmore",
    openInNewWindow = "openInNewWindow",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.CustomMenuItem]: CustomMenuModelINT[];
        [fields.linklearnmore]: string;
        [fields.openInNewWindow]: boolean;
    };
}
// const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
//     const link = getLink(state, ownProps.fields.linklearnmore);
//     return { pageUrl: link?.url };
// };
type Props = OwnProps;

export interface CustomMenuStylesINT {
    MenuContainer?: InjectableCss;
    MenuHeading?: TypographyPresentationProps;
    CustomMenuRow?: InjectableCss;
    CustomMenufly?: InjectableCss;
    customflyImgWrapper?: InjectableCss;
    customDescriptionText?: TypographyPresentationProps;
    customFlyTitle?: TypographyPresentationProps;
    menuInnerContainer?: InjectableCss;
    articleBlocks?: InjectableCss;
}

export const customMenuStyles: CustomMenuStylesINT = {
    MenuContainer: {
        css: css`
            display: flex;
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        flex-wrap: wrap;
                        justify-content: space-around;
                        &:last-child {
                            margin: 35px 0px 25px 0px;
                        }
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    MenuHeading: {
        variant: "h4",
        css: css`
            display: none;
        `,
    },
    CustomMenuRow: {
        css: css`
            display: flex;
            justify-content: center;
            width: 100%;
            align-items: center;
            margin-bottom: 10px;
            flex-wrap: wrap;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-wrap: wrap;
                        justify-content: space-around;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    CustomMenufly: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            &:not(:last-child) {
                margin-right: 25px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    customflyImgWrapper: {
        css: css`
            box-sizing: border-box;
            width: 100%;
            > div {
                margin-top: 10px;
            }

            img {
                width: 100%;
                height: 150px !important;
                object-fit: cover;
                aspect-ratio: 16/9;
            }
        `,
    },
    customFlyTitle: {
        variant: "p",
        css: css`
            color: #333333;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 24px;
            text-transform: uppercase;
            margin-bottom: 3px;
            // padding-left: 5px;
            margin-top: 8px;
        `,
    },
    customDescriptionText: {
        variant: "p",
        css: css`
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
            color: #333333;
            margin-bottom: 0;
        `,
    },
    menuInnerContainer: {
        css: css`
            display: inline-block;
            width: 100%;
        `,
    },
    articleBlocks: {
        css: css`
            margin-bottom: 15px;
            margin-right: 15px;
            :only-child {
                margin-right: 0px;
                width: 230px;
                img {
                    height: 170px;
                }
            }
            @media not all and (min-resolution: 0.001dpcm) {
                // Safari 11+
                @supports (-webkit-appearance: none) and (stroke-color: transparent) {
                    display: inline-block;
                }
                //Safari 10.1
                @supports (-webkit-appearance: none) and (not (stroke-color: transparent)) {
                    display: inline-block;
                }
            }
        `,
    },
};

const styles = customMenuStyles;

const INTCustomMenu: React.FC<Props> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.MenuContainer}>
            <Typography {...styles.MenuHeading}>{fields.title}</Typography>
            {fields.menuItem.length > 0 ? (
                <StyledWrapper id="team-row" {...styles.menuInnerContainer}>
                    {fields.menuItem.map((member, index) => {
                        return (
                            <StyledWrapper
                                id="each-column"
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                                {...styles.articleBlocks}
                            >
                                {member.fields.image && (
                                    <StyledWrapper {...styles.customflyImgWrapper}>
                                        <LazyImage src={member.fields.image} altText={member.fields.title} />
                                    </StyledWrapper>
                                )}
                                {member.fields.title && (
                                    <Typography {...styles.customFlyTitle}>{member.fields.title}</Typography>
                                )}
                                {member.fields.description && (
                                    <Typography {...styles.customDescriptionText}>
                                        {member.fields.description}
                                    </Typography>
                                )}
                                <Button
                                    css={css`
                                        background-color: #fff;
                                        border: 0;
                                        color: #006bc0;
                                        padding-left: 0px;
                                        display: flex;
                                        align-items: center;
                                        font-weight: 600;
                                        &:hover {
                                            background-color: #fff;
                                        }
                                        &:focus {
                                            outline: none;
                                            border: none;
                                        }
                                    `}
                                    id="btn"
                                >
                                    <a
                                        href={member.fields.linklearnmore}
                                        target={member.fields.openInNewWindow ? "_blank" : ""}
                                    >
                                        {member.fields.overrideTitle}
                                    </a>
                                    <Icon
                                        id="btnicon"
                                        css={css`
                                            margin-left: 10px;
                                            > svg {
                                                width: 15px;
                                                stroke: #006bc0;
                                            }
                                        `}
                                        src={ChevronRight}
                                    />
                                </Button>
                            </StyledWrapper>
                        );
                    })}
                </StyledWrapper>
            ) : null}
        </StyledWrapper>
    );
};

const membersList: WidgetModule = {
    component: INTCustomMenu,
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 0,
            },
            {
                name: fields.CustomMenuItem,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                defaultValue: [],
                fieldType: "Translatable",
                sortOrder: 1,
                fieldDefinitions: [
                    {
                        name: "image",
                        displayName: "Photo",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        name: "title",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "description",
                        displayName: "Description",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    // {
                    //     name: "link",
                    //     displayName: "Link",
                    //     editorTemplate: "LinkField",
                    //     defaultValue: { type: "Page", value: "" },
                    // },
                    {
                        name: "linklearnmore",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "openInNewWindow",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                    {
                        name: "overrideTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        displayName: "OverrideTitle",
                    },
                ],
            },
        ],
    },
};

export default membersList;
